import { render, staticRenderFns } from "./AddWorkPopup.vue?vue&type=template&id=02910b20&"
import script from "./AddWorkPopup.vue?vue&type=script&lang=js&"
export * from "./AddWorkPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports